export const ORDERS_PATH = '/orders'

/** Дефолтный статус-фильтр обычного филиала (в URL не пишется). */
export const DEFAULT_FILIAL_FILTER = 'inWork'

/** Дефолтная вкладка колл-центра (в URL не пишется). */
export const DEFAULT_CALL_CENTER_TAB = 'main'

/** Минимальная длина поискового запроса. */
export const MIN_SEARCH_LENGTH = 4

/**
 * Строка поиска из URL или null.
 */
export function getSearchFromRoute (route) {
  const value = route && route.query ? route.query.search : null
  return typeof value === 'string' && value.length ? value : null
}

/**
 * Сырое значение фильтра из URL или null (без проверки на допустимость).
 */
export function getRawFilterFromRoute (route) {
  const value = route && route.query ? route.query.filter : null
  return typeof value === 'string' && value.length ? value : null
}

/**
 * Фильтр из URL с откатом к дефолту, если значение неизвестно.
 */
export function getFilterFromRoute (route, allowedValues, defaultValue) {
  const value = getRawFilterFromRoute(route)
  return allowedValues.includes(value) ? value : defaultValue
}

/**
 * Фильтр, который нужно сохранить при навигации из поиска.
 * За пределами страницы заказов фильтра нет.
 */
export function getFilterToPreserve (route) {
  return route && route.path === ORDERS_PATH ? getRawFilterFromRoute(route) : null
}

/**
 * Query для /orders: пустые значения не пишутся.
 */
export function buildOrdersQuery ({ search = null, filter = null } = {}) {
  const query = {}
  if (filter) {
    query.filter = filter
  }
  if (search) {
    query.search = search
  }
  return query
}

function isSameOrdersLocation (route, query) {
  return (
    route.path === ORDERS_PATH &&
    (route.query.search || null) === (query.search || null) &&
    (route.query.filter || null) === (query.filter || null)
  )
}

function ignoreDuplicated (err) {
  if (err && (err.name === 'NavigationDuplicated' || /Avoided redundant navigation/.test(err.message || ''))) {
    return
  }
  throw err
}

/**
 * Переход на /orders с записью в историю. Повтор того же адреса игнорируется.
 */
export function pushOrdersRoute (router, query) {
  if (isSameOrdersLocation(router.currentRoute, query)) {
    return Promise.resolve()
  }
  return router.push({ path: ORDERS_PATH, query }).catch(ignoreDuplicated)
}
